import * as PIXI from 'pixi.js';
import {getNearestTierTexture, Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

export class CorvetteHarrierGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    const res = PIXI.Loader.shared.resources;

    // Left
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: -1,
      x: -5,
      y: 33,
      scale: 2,
    }));

    // Right
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 1,
      x: 9,
      y: 33,
      scale: 2,
    }));

    const shipTexture = getNearestTierTexture(ship.getHighestModuleTier(), 'ships', 'corvette_harrier_t%.png')
    if (shipTexture) {
      const sprite = new PIXI.Sprite(shipTexture);
      this.addChild(sprite);
    }
  }

  getSize(): number {
    return HullSize.Normal;
  }
}
